var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header_goods"},[_c('meta',{attrs:{"name":"viewport","content":"width=device-width,intial-scale=0,maximum-scale=0,user-scalable=yes,shrink-to-fit=no"}}),_vm._v(" "),_c('div',{staticClass:"header_content1"},[_c('div',{staticClass:"header_logo"},[_c('img',{attrs:{"src":require('@/assets/img/logo.png')}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ce5deac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Smainl.vue
// module id = null
// module chunks = 